// @ts-ignore
/* eslint-disable */
import { request } from '@/utils/request';
export async function getApiTest(options?: { [key: string]: any }) {
  return request<API.WebApiResponseString>('/api/Test', {
    method: 'GET',
    ...(options || {}),
  });
}
export async function getApiTestHealth(options?: { [key: string]: any }) {
  return request<API.WebApiResponseHealthCheckResultDto>('/api/Test/health', {
    method: 'GET',
    ...(options || {}),
  });
}
export async function getApiTestLog(options?: { [key: string]: any }) {
  return request<API.WebApiResponseString>('/api/Test/log', {
    method: 'GET',
    ...(options || {}),
  });
}
